import {Form, FormField, Option} from 'platform/components';
import {Box, HStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {FormToDataGridConnectorProps} from 'features/eag-grid';

import {StorageLocationFiltersValues} from '../types/StorageLocationFiltersValues';

type StorageLocationFiltersProps = FormToDataGridConnectorProps & {
  warehouseOptions: Option[];
};

function getStringArray(value: unknown): string[] | undefined {
  if (Array.isArray(value) && value.every((item) => typeof item === 'string')) {
    return value;
  }
  return undefined;
}

export function StorageLocationFilters(props: StorageLocationFiltersProps) {
  const tireWarehouse = getStringArray(props.values.tireWarehouse);
  const isAvailableOnly = getStringArray(props.values.isAvailableOnly);

  return (
    <Form<StorageLocationFiltersValues>
      values={{
        tireWarehouse: tireWarehouse?.[0] || props.warehouseOptions[0]?.value,
        isAvailableOnly: isAvailableOnly?.includes('TRUE') ? true : false,
      }}
      onChange={(newValue) => {
        props.onChange({
          tireWarehouse: [newValue.tireWarehouse],
          isAvailableOnly: newValue.isAvailableOnly ? ['TRUE'] : undefined,
        });
      }}
    >
      {(control) => (
        <HStack align="center" spacing={4}>
          <Box minWidth={70}>
            <FormField
              type="choice"
              control={control}
              name="tireWarehouse"
              options={props.warehouseOptions}
              label={i18n.t('entity.warehouse.labels.warehouse')}
              isNotClearable
            />
          </Box>
          <Box paddingTop={5}>
            <FormField
              type="switch"
              control={control}
              name="isAvailableOnly"
              label={i18n.t('general.labels.availableOnly')}
            />
          </Box>
        </HStack>
      )}
    </Form>
  );
}
